import { GetServerSideProps } from 'next';
import {
    getGuidesServerSideProps,
    PageGuidesProps,
} from 'server/page-props/get-guides-server-side-props';
import { default as IndexPage } from 'pages/[lang]/[guides]/[guide]/[article]';

export default IndexPage;

export const getServerSideProps: GetServerSideProps<PageGuidesProps> = getGuidesServerSideProps;
